import { BuiltinInterface } from '../BuiltinInterface';
class IterableInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addInterface('Iterable', new IterableInterface());
};

//# sourceMappingURL=index.js.map
